var $ = bookedby.deps != null ? bookedby.deps.$ : global.$;
//var moment = bookedby.deps != null ? bookedby.deps.moment : global.moment;
var moment = require('moment-timezone');
var _ = bookedby.deps != null ? bookedby.deps._ : global._;

var ScheduleManager = function() {
  this.init();
};

ScheduleManager.prototype = {
  init: function() {
    this.schedulesMap = {};
    this.currentStoreId = null;
    this.loadedClosedDates = false;
    this.timezone = null;
    this.lastDate = null;
    this.firstDate = null;
  },

  setSchedules: function(schedules, container, lastDate) {

    if(this.firstDate == null) {
      this.firstDate = moment(_.first(schedules).date);
    }

    _.each(schedules, _.bind(function(schedule) {
      this.schedulesMap[schedule.date] = {
        date: schedule.date,
        from: schedule.startTime,
        to: schedule.endTime
      };

      var _dateMoment = moment(schedule.date);

      if (_dateMoment.isBefore(this.firstDate)) {
        this.firstDate = _dateMoment;
      }

    }, this));

    if (lastDate != null) {
      this.lastDate = moment(lastDate);
    }

    if (container.model != null) {
      var currentDate = container.model.get('date');
      if (!this.isStoreOpen(currentDate)[0]) {
        var testingDate = moment();
        var firstAvailableDate = null;
        while (firstAvailableDate == null) {
          var dateString = testingDate.format('YYYY-MM-DD');
          if ((this.schedulesMap[dateString] == null) || (this.schedulesMap[dateString].from != null)) {
            firstAvailableDate = dateString;

            // check if current moment passes the schedule.to with timezone applied since schedule doesn't have timezone applied here
            if (!this.hasScheduleForToday(dateString)) {
              firstAvailableDate = null;
              testingDate.add(1, 'days');
            }
          } else {
            testingDate.add(1, 'days');
          }
        }
        container.model.set('date', testingDate.toDate(), {ignoreUpdate: true});
      }
    }

  },

  hasScheduleForToday: function(date) {

    var schedule = this.schedulesMap[bookedby.helpers.dateFormat(date, 'YYYY-MM-DD')];

    if (moment(date).isBefore(this.firstDate)) {
      return false;
    }

    if (schedule == null) {
      return true;
    }

    // check if current moment passes the schedule.to
    if (this.timezone != null && schedule != null) {
      var dateFormatted = (date == null || date == '') ? null : bookedby.helpers.dateFormat(date, 'YYYY-MM-DD');
      var now = moment().tz(this.timezone);
      var nowSeconds = (now.format('HH')) * 3600 + (now.format('mm')) * 60;

      //If store is closed or closes in 30 minutes, return false
      if (dateFormatted == now.format('YYYY-MM-DD') && nowSeconds > (schedule.to - 1800)) {
        return false;
      }
    }
    return true;
  },

  getScheduleForDate: function(date, container) {
    if (date == null) {
      return null;
    }
    var schedule = this.schedulesMap[date];

    if (schedule == null) {
      this.loadSchedules(date, container);
    }

    return this.schedulesMap[date];
  },

  getLazyScheduleForDate: function(date) {
    if (date == null) {
      return null;
    }

    if (!this.schedulesMap)
      return null;

    return this.schedulesMap[date];
  },

  setNewStore: function (newStoreId) {
    this.currentStoreId = newStoreId;
    this.schedulesMap = {};
    this.loadedClosedDates = false;
    this.timezone = null;
  },

  isStoreOpen: function(date) {
    var dateMoment = moment(date);
    if (this.lastDate != null && dateMoment.isAfter(this.lastDate)) {
      return [false];
    }
    var schedule = this.schedulesMap[bookedby.helpers.dateFormat(date, 'YYYY-MM-DD')];
    if (schedule != null && (schedule.from == null || schedule.from > schedule.to)) {
      return [false];
    } else {
      if (!this.hasScheduleForToday(date)) {
        return [false];
      }

      return [true];
    }
  },

  loadSchedules: function(from, container, callback) {
    if (this.currentStoreId == null || this.currentStoreId == '') {
      return;
    }

    $.ajax({
      url: bookedby.routes.BOOKING.GET_STORE_SCHEDULES,
      contentType: 'application/json',
      data: {
        storeId: this.currentStoreId,
        from: this.loadedClosedDates ? from : moment().format('YYYY-MM-DD'),
        loadClosedDates: !this.loadedClosedDates
      },
      method: 'GET',
      dataType: 'jsonp',
      success: _.bind(function(data) {
        if (_.isEmpty(data.schedules)) {
          this.schedulesMap[from] = {
            from: null,
            to: null
          }
        } else {

          this.timezone = data.timezone;
          this.setSchedules(data.schedules, container, data.lastDate);
          container.render();
        }

        if (callback != null) {
          callback();
        }

        this.loadedClosedDates = true;

      }, this),
      error: _.bind(function(jqXHR, textStatus, textError) {
        console.log('Error: ' + textError);
      }, this)
    });

  }

};

module.exports = ScheduleManager;